import { render, staticRenderFns } from "./Bitacora.vue?vue&type=template&id=04aba178&scoped=true&"
import script from "./Bitacora.vue?vue&type=script&lang=js&"
export * from "./Bitacora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aba178",
  null
  
)

export default component.exports